const buildInputObject = async (formData) => {
  const requiredFields = {
    name: String,
    mail: String,
    phone: String,
    pass: String,
  };

  const optionalFields = {
    role: String,
    cognitoID: String,
    comName: String,
    comAddress: String,
    comUnit: String,
    comMail: String,
    comPhone: String,
    gate: String,
    pSpot: String,
    pNumber: String,
    pNumGuest: String,
    pAdmin: String,
    pHandcap: String,
    pSystem: String,
  };

  const input = {};

  for (const [field, transformer] of Object.entries(requiredFields)) {
    if (formData[field] === null || formData[field] === undefined) {
      throw new Error(
        `Field ${field} is required and cannot be null or undefined`
      );
    }
    let value = transformer(formData[field]).trim();
    if (value === "") {
      throw new Error(`Field ${field} is required and cannot be empty`);
    }

    input[field] = value;
  }

  for (const [field, transformer] of Object.entries(optionalFields)) {
    if (formData[field] !== null && formData[field] !== undefined) {
      const value = transformer(formData[field]).trim();
      if (value !== "") {
        input[field] = value;
      }
    }
  }

  return input;
};

// Build and validate Tenant input. Only name and email are required
const buildTenantInput = async (tenantData) => {
  const requiredTenantFields = {
    name: String,
    email: String,
  };

  const optionalTenantFields = {
    // carMake: String,
    // carModel: String,
    // licensePlate: String,
    // Apartment: String,
    // carMake2: String,
    // carModel2: String,
    // licensePlate2: String,
    // id: String,
  };

  const input = {};

  for (const [field, transformer] of Object.entries(requiredTenantFields)) {
    if (tenantData[field] === null || tenantData[field] === undefined) {
      throw new Error(`Tenant field ${field} is required`);
    }
    const value = transformer(tenantData[field]).toString().trim();
    if (value === "") {
      throw new Error(`Tenant field ${field} cannot be empty`);
    }
    input[field] = value;
  }

  for (const [field, transformer] of Object.entries(optionalTenantFields)) {
    const value =
      tenantData[field] !== null &&
      tenantData[field] !== undefined &&
      transformer(tenantData[field]).toString().trim() !== ""
        ? transformer(tenantData[field]).toString().trim()
        : undefined;
    if (value !== undefined) input[field] = value;
  }

  return input;
};

export {
  buildInputObject,
  buildTenantInput
};
